"use client";

import React, { useState } from 'react';
import { ShieldCheck, Activity, Lock, Server, Scan, Radio } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '@/components/ui/card';
import { useRevealOnScroll } from '@/hooks/useRevealOnScroll';
export default function ShieldingAndCybersecurity() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const features = [{
    title: "Oportunidades Perdidas",
    description: "Cada minuto sin automatización y sistemas inteligentes, tus competidores técnicos capturan oportunidades comerciales que deberían ser tuyas.",
    icon: <ShieldCheck className="w-10 h-10 text-primary" />,
    techSpec: "IMPACTO: CRÍTICO"
  }, {
    title: "Desventaja Competitiva Digital",
    description: "Sin presencia digital avanzada y sistemas AI, no puedes competir con empresas modernas que ya dominan sus mercados con tecnología.",
    icon: <Activity className="w-10 h-10 text-primary" />,
    techSpec: "RIESGO: MÁXIMO"
  }];
  return <section data-section-id="6032" id="la-realidad-de-tu-negocio" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-10 animate-pulse">
          <div className="w-full h-full rounded-lg border-2 border-primary/30" />
        </div>
        
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#0066ff05_1px,transparent_1px),linear-gradient(to_bottom,#0066ff05_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div ref={sectionRef} className={`flex flex-col items-center text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="flex items-center gap-2 mb-4 px-3 py-1 rounded-lg border border-secondary/30 bg-secondary/10 backdrop-blur-sm">
            <Scan className="w-4 h-4 text-secondary animate-pulse" />
            <span className="text-xs font-mono text-secondary tracking-widest uppercase">Alerta de Diagnóstico</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold tracking-tighter mb-6">
            Sin Automatización e Inteligencia Digital, <span className="text-secondary drop-shadow-[0_0_15px_rgba(255,180,0,0.4)]">Pierdes Oportunidades</span> Cada Hora
          </h2>
          
          <p className="text-muted-foreground max-w-2xl text-lg md:text-xl font-medium">
            La brecha digital es el factor crítico. Empresas sin sistemas inteligentes quedan rezagadas frente a la competencia tecnológica global.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto">
          {features.map((feature, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-${i * 200} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <Card className="h-full bg-card/40 backdrop-blur-xl border-border/50 hover:border-primary/50 transition-all duration-500 group overflow-hidden shadow-2xl">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-secondary to-transparent opacity-50 group-hover:opacity-100 transition-opacity" />
                
                <CardHeader className="pb-4">
                  <div className="flex justify-between items-start mb-4">
                    <div className="p-3 rounded-lg bg-primary/10 border border-primary/20 group-hover:bg-primary/20 transition-colors">
                      {feature.icon}
                    </div>
                    <div className="flex items-center gap-2 text-xs font-mono text-secondary bg-background/80 px-2 py-1 rounded border border-secondary/20">
                      <Radio className="w-3 h-3 animate-pulse" />
                      {feature.techSpec}
                    </div>
                  </div>
                  <CardTitle className="text-2xl font-bold text-foreground group-hover:text-primary transition-colors tracking-tight">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed font-normal">
                    {feature.description}
                  </CardDescription>
                  
                  <div className="mt-8 flex items-center gap-2 opacity-20">
                    <div className="h-[1px] flex-1 bg-secondary" />
                    <div className="w-1 h-1 rounded-lg bg-secondary" />
                    <div className="w-1 h-1 rounded-lg bg-secondary" />
                    <div className="w-1 h-1 rounded-lg bg-secondary" />
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}